import type { RegistryEntry, UiOptionSelect } from '../types';
import { clampTo } from '../../tools';

export const klingConfigs: Record<string, RegistryEntry> = {
    'kling-image-v3': {
        options: [
            {
                key: 'output_format',
                label: 'Output Format',
                type: 'select',
                options: [
                    { label: 'PNG', value: 'png' },
                    { label: 'JPEG', value: 'jpeg' },
                    { label: 'WebP', value: 'webp' },
                ],
                default: 'png',
                group: 'basic',
            } as UiOptionSelect,
            {
                key: 'shot_type',
                label: 'Shot Type',
                type: 'select',
                options: [
                    { label: 'Customize', value: 'customize' },
                    { label: 'Intelligent', value: 'intelligent' },
                ],
                default: 'customize',
                group: 'advanced',
            } as UiOptionSelect,
        ],
        toProviderOptions: (ui) =>
            ({
                output_format: clampTo(
                    ui.output_format || 'png',
                    ['png', 'jpeg', 'webp'] as const,
                    'png',
                ),
                shot_type: clampTo(
                    ui.shot_type || 'customize',
                    ['customize', 'intelligent'] as const,
                    'customize',
                ),
            }) as unknown as Record<string, Record<string, any>>,
    },
    'kling-image-o3': {
        options: [
            {
                key: 'output_format',
                label: 'Output Format',
                type: 'select',
                options: [
                    { label: 'PNG', value: 'png' },
                    { label: 'JPEG', value: 'jpeg' },
                    { label: 'WebP', value: 'webp' },
                ],
                default: 'png',
                group: 'basic',
            } as UiOptionSelect,
            {
                key: 'shot_type',
                label: 'Shot Type',
                type: 'select',
                options: [
                    { label: 'Customize', value: 'customize' },
                    { label: 'Intelligent', value: 'intelligent' },
                ],
                default: 'customize',
                group: 'advanced',
            } as UiOptionSelect,
        ],
        toProviderOptions: (ui) =>
            ({
                output_format: clampTo(
                    ui.output_format || 'png',
                    ['png', 'jpeg', 'webp'] as const,
                    'png',
                ),
                shot_type: clampTo(
                    ui.shot_type || 'customize',
                    ['customize', 'intelligent'] as const,
                    'customize',
                ),
            }) as unknown as Record<string, Record<string, any>>,
    },
};